const ICON_SCALE = 1.25;
const ICON_Y_AXIS_MARGIN = 4;

interface IconPosition {
  iconY: number;
  iconRight: number;
}

interface CalculateIconPositionProps {
  idx: number;
  iconHeight: number;
  iconWidth: number;
  insightIconTop: number;
  insightIconRight: number;
}

export const calculateIconPosition = ({
  idx,
  iconHeight,
  iconWidth,
  insightIconTop,
  insightIconRight,
}: CalculateIconPositionProps): IconPosition => {
  const iconOffsetY = idx * iconHeight * ICON_SCALE;
  const iconY = insightIconTop - iconHeight - ICON_Y_AXIS_MARGIN - iconOffsetY;
  const iconRight = insightIconRight - iconWidth / 2;

  return { iconY, iconRight };
};
